/**
 * Exposed http request error, setting the status as message
 * and keeping a reference to response and data
 */
export class FetchError<T = unknown> extends Error {
    public constructor(public response: Response, public data?: T) {
        // the trim is to remove the trailing space in case of no statusText (http2)
        super(`${response.status} ${response.statusText || ''}`.trim());
    }
}
